import React from "react";
// components
import { Button, Flex, Paper, Spacer, Title } from "components";
// Types
import { ButtonProps } from "components/Common/Button";

export interface PanelProps {
  actions?: ButtonProps[];
  title?: string;
  children?: React.ReactNode;
}

export const Panel: React.FC<PanelProps> = ({ actions = [], children, title }) => {
  return (
    <Paper>
      <Flex container containerDirection="column">
        <Flex item itemGutter>
          <Flex item itemGutter>
            <Spacer baselineHeight={2} />
            {title && (
              <>
                <Title secondary>{title}</Title>
                <Spacer baselineHeight={1} />
              </>
            )}
            {children}
          </Flex>
          <Spacer baselineHeight={2} />
        </Flex>

        {!!actions.length && (
          <>
            <Spacer border="top" baselineHeight={2} />
            <Flex container item itemGutter xs="fill" containerJustifyContent="flex-end">
              {actions.map(({ caption, colour, onClick, ...rest }) => (
                <Flex item itemGutter key={caption}>
                  <Button caption={caption} colour={colour} onClick={onClick} {...rest} />
                </Flex>
              ))}
              <Spacer baselineHeight={2} />
            </Flex>
          </>
        )}
      </Flex>
    </Paper>
  );
};
